export {
    formatActivityDate,
    formatActivityDateTime,
    LAST_LOGIN_ANY,
    STATUS_ACTIVE,
    STATUS_INVITE_EXPIRED,
    STATUS_INVITED,
} from '../../admin/users/activity/userActivityFormat';

export const STATUS_DEACTIVATED = 'deactivated';

export const ORG_ROLE_ADMIN = 'organisation_admin';
export const ORG_ROLE_USER = 'organisation_user';

export const MFA_ALL = 'all';
export const PROJECT_NONE = 'none';

export const PER_PAGE_OPTIONS = [25, 50, 100];

export const DEFAULT_QUERY = {
    search: null,
    project: null,
    org_role: null,
    status: null,
    last_login: 'any',
    mfa: MFA_ALL,
    sort: 'name',
    direction: 'asc',
    per_page: 25,
};

// The design's form controls and dialog buttons, layered over the shared
// text-input / select-input / button styles, which are bold and a step larger.
// Filled field: light grey, borderless, regular weight.
export const FILLED_FIELD = '!tw-h-[38px] !tw-rounded-lg !tw-border-0 !tw-bg-charcoal-10 !tw-px-3 !tw-py-0 !tw-text-sm !tw-font-normal !tw-text-charcoal';
export const FILLED_SELECT = `${FILLED_FIELD} !tw-pe-8`;
// Compact white select inside a project row.
export const ROW_SELECT =
    '!tw-h-[27px] !tw-w-full !tw-rounded-md !tw-border !tw-border-solid !tw-border-charcoal-25 !tw-bg-white !tw-py-0 !tw-ps-1.5 !tw-pe-7 !tw-text-xs !tw-font-normal !tw-text-charcoal disabled:!tw-text-charcoal-50';
// Dialog footer buttons; the soft one is the light grey pill the panel's Close uses.
export const DIALOG_BUTTON = '!tw-h-[34px] !tw-px-[18px] !tw-text-0.5sm !tw-font-medium';
export const SOFT_BUTTON = `${DIALOG_BUTTON} !tw-bg-charcoal-15 !tw-text-charcoal hover:!tw-bg-charcoal-25`;
// A refused destructive action stays red, faded, rather than turning grey.
export const DANGER_BUTTON = `${DIALOG_BUTTON} disabled:!tw-bg-red disabled:!tw-text-white disabled:!tw-opacity-[0.45]`;

export const orgRoleLabel = (orgRole) => (orgRole === ORG_ROLE_ADMIN ? $t('Organisation Admin') : $t('Organisation user'));

export const isInvitePending = (status) => status === 'invited' || status === 'invite_expired';

/**
 * The page's query as request parameters: empty filters are left out.
 */
export function queryParams(query) {
    const params = {};

    Object.entries(query).forEach(([key, value]) => {
        if (value !== null && value !== '' && value !== undefined) {
            params[key] = value;
        }
    });

    return params;
}
